// import LeavePresenter from "../Leave/LeavePresenter";
import BasePage from "../../../base/BasePage";
import RegionTab from "../../../components/common/RegionTab";
import HrddForApprovalPage from "./HRDDLeave/HrddForApprovalPage";
import MonetizationHrddPage from "./HRDDMonetization/MonetizationHrddPage";

class HRDDApplication extends BasePage {
  constructor(props) {
    super(props);
    // this.presenter = new LeavePresenter(this, addSchemaUseCase());
    this.state = {
      progress: false,
    };
  }

  render() {
    const tabs = [
      { title: "Leave Requests", content: <HrddForApprovalPage /> },
      // { title: "Monetization Requests", content: <MonetizationHrddPage /> },
    ];
    const tabContents = tabs.map((tab) => tab.content);
    return (
      <>
        <div
          className="container-fluid d-flex flex-column p-5"
          style={{ marginTop: "4rem" }}
        >
          <div
            className="d-flex mb-4"
            style={{ borderBottom: "1px solid #d3d3d3" }}
          >
            <p style={{ fontSize: "14px", color: "grey" }}>
              You are here: Home &gt; Human Resource &gt;{" "}
              <span style={{ color: "#333" }}>HRDD for Approval</span>
            </p>
          </div>
          <RegionTab tabs={tabs} tabContents={tabContents} />
        </div>
      </>
    );
  }
}

export default HRDDApplication;
